<template lang="pug">
div
  v-breadcrumbs.py-4(:items="breadcrumbItems")
    template(v-slot:item="{ item }")
      a.text-xs.no-underline.primary--text(v-if="!item.disabled" :href="item.href") {{ item.text }}
      .text-xs.primary400--text(v-else) {{ item.text }}
  v-divider.mb-2
  v-container
    v-tabs.y-tabs(v-model="currentTab")
      v-tabs-slider
      v-tab
        v-icon.mr-4(color="success" v-if="currentTab > 0") $yzi-check-circle
        .text-sm.text-none.font-medium 1. Upload CSV
      v-tab(:class="{ 'tab-disabled': currentTab < 1 }")
        v-icon.mr-4(color="success" v-if="currentTab > 1") $yzi-check-circle
        .text-sm.text-none.font-medium 2. Map Fields
      v-tab(:class="{ 'tab-disabled': currentTab < 2 }")
        .text-sm.text-none.font-medium 3. Review
    v-divider
    v-tabs-items.pb-16(v-model="currentTab")
      v-tab-item
        upload-csv(
          :parentFile.sync="inputFile"
          type="customers"
          os="connect"
          @onContinue="onContinueUpload"
        )
      v-tab-item
        template(v-if="mappingResponse && inputFile")
          map-fields(
            :data="mappingResponse"
            :inputFile="inputFile"
            type="customers"
            os="connect"
            @onValidate="onValidate"
            @onMapping="onMapping"
          )
      v-tab-item
        review-import(
          :data="validateResponse"
          :inputFile="inputFile"
          :mapperFormData="mapperFormData"
          type="customers"
          os="connect"
          @onReupload="onReupload"
        )
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import UploadCsv from '@/components/module/upload/UploadCsv.vue'
import ReviewImport from '@/components/module/upload/ReviewImport.vue'
import MapFields from '@/components/module/upload/MapFields'

export default {
  components: {
    UploadCsv,
    ReviewImport,
    MapFields
  },
  data: () => ({
    currentTab: 0,
    breadcrumbItems: [
      {
        text: 'Customers',
        disabled: false,
        href: '/admin/connect/customers'
      },
      {
        text: 'Import customers from CSV',
        disabled: true
      }
    ],
    inputFile: null,
    isUploading: false,
    mappingResponse: null,
    validateResponse: null,
    mapperFormData: null
  }),
  computed: {
    ...mapGetters({
      company: 'getCompany',
    })
  },
  methods: {
    ...mapActions(['showMessage']),
    onContinueUpload(response) {
      this.currentTab = 1
      this.mappingResponse = response
    },
    onValidate(response) {
      this.validateResponse = response
      this.currentTab = 2
    },
    onMapping(response) {
      this.mapperFormData = response
    },
    onReupload() {
      this.inputFile = null
      this.currentTab = 0
    }
  }
}
</script>
